import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import IconKeyboardArrowUp from '@servicetitan/anvil2/assets/icons/material/round/keyboard_arrow_up.svg';
import IconKeyboardArrowDown from '@servicetitan/anvil2/assets/icons/material/round/keyboard_arrow_down.svg';
import { Avatar, Button, Divider, Flex, Icon, Menu, Overflow, Text } from '@servicetitan/anvil2';
import { core } from '@servicetitan/anvil2/token';
import IconPerson from '@servicetitan/anvil2/assets/icons/material/round/person.svg';
import IconDarkMode from '@servicetitan/anvil2/assets/icons/material/round/dark_mode.svg';
import IconLightMode from '@servicetitan/anvil2/assets/icons/material/round/light_mode.svg';

import { AuthStore } from '../../stores/auth.store';
import { useThemeMode } from '../../theme/theme-mode';
import Logo from '../../assets/st-logo.svg?component';

import * as Styles from './header.module.scss';

export const Header = observer(() => {
    const [{ user, logout }] = useDependencies(AuthStore);
    const { mode, toggleMode } = useThemeMode();

    return (
        <header className={Styles.header}>
            <div>
                <Link to="/" className={Styles.logo}>
                    <Logo />
                </Link>
            </div>

            <Flex columnGap="2" alignItems="center" className="header-user">
                <Button
                    appearance="ghost"
                    icon={mode === 'dark' ? IconLightMode : IconDarkMode}
                    aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                    onClick={toggleMode}
                />
                {user && (
                    <Menu
                        trigger={props => {
                            return (
                                <Button {...props}>
                                    <Avatar
                                        color={core.semantic.BackgroundColorPrimary.value}
                                        size="small"
                                        name={user.name ?? user.titanGuid}
                                    />
                                    <Icon
                                        svg={
                                            props['data-state'] === 'open'
                                                ? IconKeyboardArrowUp
                                                : IconKeyboardArrowDown
                                        }
                                    />
                                </Button>
                            );
                        }}
                    >
                        <div className={Styles.accountMenuContent}>
                            <Flex className="p-2" columnGap="1" alignItems="center">
                                <Icon
                                    size="large"
                                    svg={IconPerson}
                                    color={core.semantic.ForegroundColorSubdued.value}
                                />

                                <Overflow.Text rows={1} expandable={false}>
                                    <Text subdued>{user.name ?? user.titanGuid}</Text>
                                </Overflow.Text>
                            </Flex>
                            <Divider spacing="half" />
                            <Menu.Item label="Logout" onClick={logout} />
                        </div>
                    </Menu>
                )}
            </Flex>
        </header>
    );
});
